import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { RovoDevAgentsLogo } from "@/components/signup/utils/logos/rovo-dev-agents-logo";

import { GetStartedHeading } from "../../../components/get-started-heading";

export const LoggedOutDevAIFree = () => {
    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <GetStartedHeading productName="Rovo Dev Agents" />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
